import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  style: {"position":"relative"},
  class: "map-card-imgbanner"
}
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 1,
  class: "imageErrorMessage"
}
const _hoisted_4 = ["src", "alt"]

import { ref, watch, onMounted, toRefs } from "vue";
import { removeImageScaler } from "@/core";

interface Props {
  src: string;
  alt: string;
  isNeighborhoodImage: boolean;
  showDefaultImage?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LazyImage',
  props: {
    src: {},
    alt: {},
    isNeighborhoodImage: { type: Boolean },
    showDefaultImage: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;
const { src, alt, isNeighborhoodImage, showDefaultImage } = toRefs(props);

const imageError = ref("");
const neighborhoodImageError = ref(false);
const cssClassImageLoaded = ref(false);
const cssDefaultImage = ref(showDefaultImage?.value ?? false);
const imgUrl = ref(src.value);
const lastFailedUrl = ref("");

watch(src, () => {
  imageError.value = "";
  neighborhoodImageError.value = false;
  cssClassImageLoaded.value = false;
  cssDefaultImage.value = showDefaultImage?.value ?? false;
  lastFailedUrl.value = "";
  imgUrl.value = src.value;
});

onMounted(() => {
  imgUrl.value = src.value;
  cssDefaultImage.value = showDefaultImage?.value ?? false;
});

const handleImageLoad = () => {
  cssClassImageLoaded.value = true;
};

const onImageError = () => {
  // Both <img> elements below share `imgUrl`, so one broken URL fires this
  // handler twice. Without this guard the second event would skip the unscaled
  // retry and jump straight to the placeholder.
  if (lastFailedUrl.value === imgUrl.value) {
    return;
  }
  lastFailedUrl.value = imgUrl.value;

  if (isNeighborhoodImage.value) {
    neighborhoodImageError.value = true;
    imageError.value = alt.value.charAt(0);
    return;
  }

  const unscaledUrl = removeImageScaler(src.value);
  if (!cssDefaultImage.value && unscaledUrl && unscaledUrl !== imgUrl.value) {
    cssDefaultImage.value = true;
    imgUrl.value = unscaledUrl;
    return;
  }

  imgUrl.value = require("@/assets/images/home-not-available.png");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!cssClassImageLoaded.value && !_unref(isNeighborhoodImage))
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: imgUrl.value,
          alt: _unref(alt),
          onError: onImageError,
          class: _normalizeClass([
        cssClassImageLoaded.value ? 'lazyimg-fade-out' : '',
        'lazyimg op-1',
        { fitImage: cssDefaultImage.value },
      ])
        }, null, 42, _hoisted_2))
      : _createCommentVNode("", true),
    (_unref(isNeighborhoodImage) && neighborhoodImageError.value)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(imageError.value), 1))
      : _createCommentVNode("", true),
    (!neighborhoodImageError.value)
      ? (_openBlock(), _createElementBlock("img", {
          key: 2,
          src: imgUrl.value,
          alt: _unref(alt),
          onLoad: handleImageLoad,
          onError: onImageError,
          class: _normalizeClass([
        cssClassImageLoaded.value ? 'lazyimg-fade-in' : '',
        'lazyimg op-0',
        { fitImage: cssDefaultImage.value },
      ])
        }, null, 42, _hoisted_4))
      : _createCommentVNode("", true)
  ]))
}
}

})